import { AppState } from '@chegg-wt/core/state'
import { createSelector } from 'reselect'
import { UserStyles } from '@chegg-wt/core/utils/userStyles'
import { Project } from '@chegg-wt/core/types/core'
import { userRoleSelector } from '../user/selectors'
import { basicProStyles, ProjectTypeKeyToTitle } from './constants'
import { MaybeProjectTypeKeyToTitleTypes, StyleOption } from './types'

export const projectsSelector = (state: AppState): Project[] =>
  state.projects.currentProjects
export const areProjectsLoadingSelector = (state: AppState) => state.projects.isLoading
export const projectSearchSelector = (state: AppState) => state.projects.projectSearch
export const projectFilterSelector = (state: AppState) => state.projects.filter
export const projectsSortNameSelector = (state: AppState) => state.projects.sortName
export const projectsOrderSelector = (state: AppState) => state.projects.order

export const basicProjectStylesSelector = createSelector(
  [userRoleSelector],
  (userRole): StyleOption[] => {
    const userStyles = new UserStyles(userRole)
    return basicProStyles.filter((style) => userStyles.isStyleAllowed(style.value))
  }
)

export const projectsByIndexSelector = (
  state: AppState,
  props: { ids: string[] }
): Project[] =>
  props.ids
    .map((id) => state.projects.currentProjects.find((project) => project.id === id))
    .filter((x) => x)

export const projectByIdSelector = (projectId: string) =>
  createSelector([projectsSelector], (projects) =>
    projects.find((project) => project.id === projectId)
  )

export const projectTypeNameSelector = createSelector(
  projectFilterSelector,
  (projectType): MaybeProjectTypeKeyToTitleTypes =>
    ProjectTypeKeyToTitle[projectType] || ''
)
